import fallbackImg from '../../assets/user.png'; // Import the fallback image

export const userColumns = [
  { 
    field: "id",
    headerName: "ID",
    width: 200 
  },
  {
    field: "imgurl",
    headerName: "Image",
    width: 30,
    renderCell: (params) => {
      const imgSrc = params.row.imgurl || fallbackImg; // Use fallback image if img is null
      return (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={imgSrc}
            alt="avatar"
            onError={(e) => (e.target.src = fallbackImg)} // Fallback on error
          />
          {params.row.username}
        </div>
      );
    },
  },

  {
    field: "doctorName",
    headerName: "Name",
    width: 150,
  },
  {
    field: "specialist",
    headerName: "Specialist",
    width: 150,
  },
  {
    field: "clinicname",
    headerName: "Clinic Name",
    width: 200,
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
  },

 
];
